// Transparent Header für Dawn Theme

document.addEventListener('DOMContentLoaded', function() {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const headerSection = document.querySelector('.section-header');
  const announcementBar = document.querySelector('.announcement-bar-section');
  
  if (!headerGroup || !headerSection) return;
  
  // Prüfe ob transparenter Header aktiviert werden soll
  const shouldBeTransparent = checkTransparentHeader();
  
  if (shouldBeTransparent) {
    activateTransparentHeader();
  }
  
  function checkTransparentHeader() {
    const currentTemplate = document.body.dataset.template || '';
    
    // Prüfe für Banner mit Overlay
    const bannerWithOverlay = document.querySelector('[data-overlay-header="true"]');
    if (bannerWithOverlay) {
      return true;
    }
    
    // Prüfe für Seitentypen (diese Werte müssen vom Header-Schema kommen)
    const headerData = headerSection.dataset;
    
    if (currentTemplate === 'index' && headerData.transparentHome === 'true') {
      return true;
    }
    
    if (currentTemplate.includes('product') && headerData.transparentProduct === 'true') {
      return true;
    }
    
    if (currentTemplate.includes('collection') && headerData.transparentCollection === 'true') {
      return true;
    }
    
    return false;
  }
  
  function activateTransparentHeader() {
    headerGroup.classList.add('header-transparent');
    
    // Header-Höhe setzen
    const headerHeight = headerSection.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    
    // Ankündigungsleiste-Höhe setzen
    if (announcementBar) {
      const announcementHeight = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
    
    // Scroll-Event für Hover-Effekt
    window.addEventListener('scroll', function() {
      const scrolled = window.pageYOffset > 50;
      
      if (scrolled) {
        headerGroup.classList.add('header-scrolled');
      } else {
        headerGroup.classList.remove('header-scrolled');
      }
    });
    
    // Update Höhen bei Resize
    window.addEventListener('resize', function() {
      const headerHeight = headerSection.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      
      if (announcementBar) {
        const announcementHeight = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      }
    });
  }
});